const tours = {
  tour: "Chuyến du lịch", // translated 
  tours: "Các tour du lịch", // translated 
  addOn: "Thêm vào", // translated 
  addOns: "Các tiện ích bổ sung", // translated 
  availableEscapes: "Các chuyến đi có sẵn", // translated 
  availableExperiences: "Các trải nghiệm có sẵn", // translated 
  getRequest: "Nhận yêu cầu", // translated 
  sendRequest: "Gửi yêu cầu", // translated 
};


export default tours;
